import { useState } from 'react';

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What services does LumanyiTech offer?',
      answer: 'We provide end-to-end business solutions including website development, graphic design & branding, research & market insights, data analysis & data science, business solutions, FinTech solutions, business compliance & financial systems, and comprehensive agribusiness support.'
    },
    {
      question: 'How long does a typical project take?',
      answer: 'Project timelines vary based on scope and complexity. A standard website typically takes 4-6 weeks, while more complex solutions like data analytics platforms or agribusiness transformations may take 8-12 weeks. We provide detailed timelines during the consultation phase.'
    },
    {
      question: 'Do you work with startups or only established businesses?',
      answer: 'We work with businesses at every stage — from startups needing their first website to established enterprises requiring digital transformation. Our solutions are tailored to meet you where you are and help you grow.'
    },
    {
      question: 'What makes your agribusiness division unique?',
      answer: 'Our agribusiness division offers integrated support across the entire value chain — from production and certification to market access and digital transformation. We use an embedded partnership model, working alongside you as a strategic partner rather than just a service provider.'
    },
    {
      question: 'Do you provide ongoing support after project completion?',
      answer: 'Yes! We offer 24/7 support and maintenance packages for all our solutions. Whether it\'s website updates, system monitoring, or strategic consulting, we\'re here to ensure your continued success.'
    },
    {
      question: 'How do I get started?',
      answer: 'Simply reach out through our contact page or give us a call. We\'ll schedule a free consultation to understand your needs, discuss potential solutions, and provide a detailed proposal with timelines and pricing.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="w-full px-4 sm:px-8 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#3782df]/10 rounded-full mb-6">
            <div className="w-2 h-2 bg-[#3782df] rounded-full"></div>
            <span className="text-[#3782df] text-sm font-medium">FAQ</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Got questions? We've got answers. Here are some of the most common questions we receive.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left hover:bg-gray-50 transition-colors"
              >
                <span className="text-base font-semibold text-gray-900 flex-1">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full bg-[#3782df]/10 transition-transform ${
                  activeIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-xl text-[#3782df]"></i>
                </div>
              </button>
              {activeIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}